export function Logo({ className = "" }: { className?: string }) {
  return (
    <div className={`flex justify-center ${className}`}>
      <img
        src="/images/splash.png"
        alt="Logo"
        className="h-32 w-auto drop-shadow-lg"
      />
    </div>
  );
}
